import { useEmail } from '@/components/providers/EmailProvider/EmailProvider';
import type { Party } from '@/features/party/types';
import usePolicies from '@/features/policies/queries/hooks/usePolicies';
import type { Policy } from '@/features/policies/types';

import { getPolicyRef } from '../utils/anva/utils';

export default function useOnlyRelevantAnvaPolicyRef(party: Maybe<Party>) {
  const {
    analysis: {
      relevant: { policyIds },
    },
  } = useEmail();

  const { data: policies } = usePolicies(
    party?.id ?? '',
    { activeOnly: true },
    { enabled: Boolean(party?.id) },
  );

  const isAnvaPolicy = (policy: Policy) =>
    Boolean(policy.external_refs?.find((ref) => ref.company === 'ANVA'));

  const isRelevant = (policy: Policy) =>
    Boolean(policyIds?.includes(policy.id));

  const relevantAnvaPolicies = policies?.filter(
    (policy) => isAnvaPolicy(policy) && isRelevant(policy),
  );

  const onlyRelevantPolicy =
    relevantAnvaPolicies?.length === 1 ? relevantAnvaPolicies[0] : undefined;

  console.log({
    relevantAnvaPolicies,
    onlyRelevantPolicy,
  });

  return onlyRelevantPolicy ? getPolicyRef(onlyRelevantPolicy) : undefined;
}
